import { createGlobalStyle } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

/**
 * This is global css passed a s a child of ThemeProvider in
 * `src/horizon/index.tsx`. It should contain only global styles that
 * don't fit nicely as a style of a specific component, e.g. scrollbars.
 *
 * TODO: consider moving appropriate items from App.css here.
 */

export const GlobalStyles = createGlobalStyle`
  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
    html, body {
      scrollbar-color: ${theme.borderColor} ${theme.tertiaryBackgroundColor};

      ::-webkit-scrollbar-track {
        background-color: ${theme.tertiaryBackgroundColor};
      }
  
      ::-webkit-scrollbar-thumb {
        background-color: ${theme.borderColor};
      }

      h1, h2, h3, h4, h5, h6 {
        color: ${theme.headerColor};
      }

      div, p, span, i, em, b, strong {
        color: ${theme.textColor};
      }

      button, a {
        div, p, span, i, em, b, strong {
          color: unset;
        }
      }

      label {
        color: ${theme.labelColor};
      }
    }
  `}
`;
